export var Xbox360ControllerButtons;
(function (Xbox360ControllerButtons) {
    Xbox360ControllerButtons[Xbox360ControllerButtons["A"] = 0] = "A";
    Xbox360ControllerButtons[Xbox360ControllerButtons["B"] = 1] = "B";
    Xbox360ControllerButtons[Xbox360ControllerButtons["X"] = 2] = "X";
    Xbox360ControllerButtons[Xbox360ControllerButtons["Y"] = 3] = "Y";
    Xbox360ControllerButtons[Xbox360ControllerButtons["LeftBumper"] = 4] = "LeftBumper";
    Xbox360ControllerButtons[Xbox360ControllerButtons["RightBumper"] = 5] = "RightBumper";
    Xbox360ControllerButtons[Xbox360ControllerButtons["LeftTrigger"] = 6] = "LeftTrigger";
    Xbox360ControllerButtons[Xbox360ControllerButtons["RightTrigger"] = 7] = "RightTrigger";
    Xbox360ControllerButtons[Xbox360ControllerButtons["Select"] = 8] = "Select";
    Xbox360ControllerButtons[Xbox360ControllerButtons["Start"] = 9] = "Start";
    Xbox360ControllerButtons[Xbox360ControllerButtons["L3"] = 10] = "L3";
    Xbox360ControllerButtons[Xbox360ControllerButtons["R3"] = 11] = "R3";
    Xbox360ControllerButtons[Xbox360ControllerButtons["DpadUp"] = 12] = "DpadUp";
    Xbox360ControllerButtons[Xbox360ControllerButtons["DpadDown"] = 13] = "DpadDown";
    Xbox360ControllerButtons[Xbox360ControllerButtons["DpadLeft"] = 14] = "DpadLeft";
    Xbox360ControllerButtons[Xbox360ControllerButtons["DpadRight"] = 15] = "DpadRight";
})(Xbox360ControllerButtons || (Xbox360ControllerButtons = {}));
export class ControllerManager {
    // MultiNostalgia patch: writes the owning Gameboy's Input instance
    // (was a shared module singleton). queryButtons is inert in our flow
    // (dropped from the frame loop — see PATCHES.md); kept for a future
    // browser gamepad wrapper, now correctly per-instance.
    input;
    controller = 0;
    left = Xbox360ControllerButtons.DpadLeft;
    right = Xbox360ControllerButtons.DpadRight;
    up = Xbox360ControllerButtons.DpadUp;
    down = Xbox360ControllerButtons.DpadDown;
    select = Xbox360ControllerButtons.Select;
    start = Xbox360ControllerButtons.Start;
    b = Xbox360ControllerButtons.X;
    bAlt = Xbox360ControllerButtons.Y;
    a = Xbox360ControllerButtons.A;
    aAlt = Xbox360ControllerButtons.B;
    constructor(input) {
        this.input = input;
    }
    queryButtons() {
        const gamepad = navigator.getGamepads()[this.controller];
        if (!gamepad) {
            return;
        }
        this.input.isPressingLeft = gamepad.buttons[this.left].pressed || gamepad.axes[0] < -0.1;
        this.input.isPressingRight = gamepad.buttons[this.right].pressed || gamepad.axes[0] > 0.1;
        this.input.isPressingUp = gamepad.buttons[this.up].pressed || gamepad.axes[1] < -0.1;
        this.input.isPressingDown = gamepad.buttons[this.down].pressed || gamepad.axes[1] > 0.1;
        this.input.isPressingSelect = gamepad.buttons[this.select].pressed;
        this.input.isPressingStart = gamepad.buttons[this.start].pressed;
        this.input.isPressingB = gamepad.buttons[this.b].pressed || gamepad.buttons[this.bAlt].pressed;
        this.input.isPressingA = gamepad.buttons[this.a].pressed || gamepad.buttons[this.aAlt].pressed;
    }
}
//# sourceMappingURL=controller-manager.js.map